module.exports = __webpack_public_path__ + "static/media/rcoe_logo.a91684a5.png";